export default __webpack_public_path__ + "static/media/engie.482494da.png";